import { browserAgent } from './agent';

type UserInfo = {
  id: string;
  email?: string;
  type?: 'brand' | 'fan';
};

export const setUser = (user: UserInfo): void => {
  browserAgent.setCustomAttribute('userId', user.id);
  if (user.email) {
    browserAgent.setCustomAttribute('userEmail', user.email);
  }
  if (user.type) {
    browserAgent.setCustomAttribute('userType', user.type);
  }
};
